const Ellipsis = ({ className = "", ...props }) => (
  <div
    className={`w-full overflow-hidden text-ellipsis whitespace-nowrap ${className}`.trim()}
    {...props}
  />
);

export default Ellipsis;
